<template>
  <div class="sc_search_select">
    <div class="group_search_select" v-click-outside="clickOut">
      <div class="button_drop_search" @click.stop="toggleSelect">
        <span v-if="label === placeholder" class="placeholder_coin">{{ label }}</span>
        <span v-else v-html="label" class="item_selected"></span>
        <img :src="isShow ? '/images/icon/icon-up.svg' : '/images/icon/icon-down.svg'" alt="icon">
      </div>
      <div class="box_list_search_select active" v-if="isShow">
        <div class="box_input_s">
          <input type="Search" ref="inputSearch" class="input_search_select" :placeholder="$t('common.search')" @keyup="doSearch($event.target.value)">
           <img src="/images/icon/icon-search.svg" alt="icon" class="icon-search">
        </div>
        <ul class="list_search_select" v-if="filteredOptions.length > 0">
          <li v-for="(option, index) in filteredOptions" @click="select(option)" :key="index">
            <span class="code_coin">{{ option.coin.toUpperCase() }}</span>
            <span class="full_name_coin">{{ option.networkName }}</span>
          </li>
        </ul>
        <div class="active no-data-search" v-if="filteredOptions.length === 0">
          <div class="empty-row text-center">
            <div class="w-100 text-center text-empty">
              {{ $t('common.datatable.no_have_data') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  props: {
    placeholder: {
      type: String,
    },
    value: {
      default: () => null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    focus: {
      type: Function,
      default: () => {},
    },
    click: {
      type: Function,
      default: () => {},
    }
  },
  data () {
    return {
      isShow: false,
      search: '',
    };
  },
  watch: {
  },
  computed: {
    filteredOptions() {
      if (!this.search) return this.options;
      return this.options.filter(item => 
        this.includes(item.mainnetTokenId, this.search) || 
        this.includes(item.networkName, this.search)
      );
    },
    label () {
      const selected = this.value;
      if (selected && selected.networkName) {
        return `<span class="code_coin_select">${selected.mainnetTokenId || ''}</span>
          <span class="full_name_coin_select">${selected.networkName}</span>`;
      }
      return this.placeholder
    },
    ...mapState({
      userThemeMode: (state) => state.userThemeMode,
    }),
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    toggleSelect () {
      this.$emit('resetErrors');
      this.isShow = !this.isShow;
      this.$nextTick(() => {
        if (this.isShow) {
          this.search = '';
          this.$refs.inputSearch.focus();
        }
      });
    },
    turnOffSelect () {
      this.isShow = false;
    },
    select (option) {
      this.$emit('input', option);
      this.search = '';
      this.turnOffSelect();
      if(this.click) {
        this.click()
      }
    },
    includes (str, query) {
      if (str === undefined || str === null) return false;
      const text = str.toString().toLowerCase();
      const value = query.trim().toString().toLowerCase();
      return text.includes(value);
    },
    doSearch(value) {
      this.search = value;
    },
    clickOut(e) {
      if (e) e.stopPropagation();
      this.isShow = false;
      this.search = '';
    },
    checkClickOn(event) {
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.sc_search_select {
  &.error {
    border: 1px solid $text-color-red;
    border-radius: 8px;
  }
  .group_search_select {
    position: relative;
    .button_drop_search {
      position: relative;
      cursor: pointer;
      padding: 12px 15px;
      background: var(--color-dark-5);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: var(--text-primary-color);
      font-size: 18px;
      line-height: 21px;
      .placeholder_coin {
        color: var(--text-desc);
      }
      .item_selected {
        display: flex;
        align-items: center;
        gap: 8px;
        color: var(--color-black_3);
        font-size: 18px;
        line-height: 21px;
        ::v-deep {
          .code_coin_select {
            font-family: $font-inter-bold;
            color: var(--text-primary-color);
            font-size: 20px;
            line-height: 24px;
          }
          .full_name_coin_select {
            font-family: $font-inter-regular;
            color: var(--text-desc);
            font-size: 14px;
            line-height: 24px;
          }
        }
      }
    }
    .no-data-search {
      color: var(--text-no-data);
      margin: 24px 0;
      height: auto;
      font-size: 18px;
    }
    .box_list_search_select {
      position: absolute;
      display: none;
      width: 100%;
      top: calc(100% + 5px);
      left: 0px;
      z-index: 7;
      padding: 14px 16px 14px 12px;
      max-height: 274px;
      overflow: auto;
      background-color: var(--bgr-dropdown);
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
    }
    .box_list_search_select.active {
      display: block;
    }
    .box_input_s {
      margin-bottom: 15px;
      display: flex;
      width: 100%;
      border-radius: 8px;
      position: relative;
      background: var(--color-dark-5);
      .icon-search {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
      }
      .input_search_select {
        width: 100%;
        border: none;
        background: none;
        height: 39px;
        outline-offset: 0px;
        padding: 10px 15px;
        color: var(--text-primary-color);
        font-size: 16px;
        &::placeholder {
          color: var(--text-search);
        }
      }       
    }
    .list_search_select {
      padding: 7px 0;
      max-height: 186px;
      overflow-y: auto;
      margin: 0;
      li {
        padding: 8px 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 10px;
        &:hover {
          background: var(--coin-input-hover);
          span {
            color: $color-caribbean-green;
          }
        }
        .icon_coin {
          height: 26px;
          width: 26px;
          img {
            height: 26px;
            width: 26px;
            object-fit: contain;
          }
        }
        .code_coin {
          font-family: $font-inter-bold;
          color: var(--text-primary-color);
          font-size: 20px;
          line-height: 24px;
        }
        .full_name_coin {
          font-family: $font-inter-regular;
          color: var(--text-desc);
          font-size: 14px;
          line-height: 24px;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
